Greenmile.MassiveSmartGeocode = Greenmile.MassiveSmartGeocode || {};

Greenmile.MassiveSmartGeocode.Form = function () {

    this.getFormData = function () {

        //Get all data
        const formData = App.Forms.MassiveSmartGeocode.form.getValues();
        
        //Clean and format data
        for (const key in formData) {
            
            //Remove radio field and its related lookup field
            if (key === 'searchBy') {
                const radioButtons = App.Forms.MassiveSmartGeocode.form.fields.searchBy.getRadioButtons();
                const radioNotChecked = radioButtons.filter(radio => !radio.input.checked)[0].getValue();
                delete formData[radioNotChecked];
                delete formData[key];
            }

            //Remove picklist if its related lookup field is empty
            if (key.includes('picklist') && !formData[key.replace('picklist','').toLowerCase()].length) {
                delete formData[key];
            }

            //Remove empty array and convert array of objects with ids into array of ids
            if (Array.isArray(formData[key])) {
                if (!formData[key].length) {
                    delete formData[key];
                } else {
                    formData[key] = formData[key].map(field => field.id);
                }
            }
        }

        return formData;
    };

    this.renderErrorMessages = function (errorMessages) {
        const monetMessage = new Monet.Form.Messages.InlineMessage();

        monetMessage.setScope('#SmartGeocode #form_and_grid');
        monetMessage.setInfoType("error");
        monetMessage.setMessage({ errorMessages });
        monetMessage.triggerMessage();
    }

    this.validateForm = function () {
        let isValid = true;
        const formData = this.getFormData();
        const errorMessages = [];
        const dateFunctions = new Monet.Date.GeneralFunctions();
        const fields = App.Forms.MassiveSmartGeocode.form.fields;

        //Check mandatory fields except date fields
        for (const key in fields) {
            const field = fields[key];
            
            if (field.isMandatory() && !key.includes('Date') && !formData[key]) {
                isValid = false;
                field.rootEl.classList.add('error');
                errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('general.mandatoryField', field.label.innerText));
            }
            else {
                field.rootEl.classList.remove('error');
                field.rootEl.parentElement.classList.remove('error');
            }
        }

        //Check date fields
        if (!formData.startDate && !formData.endDate) {
            isValid = false;
            fields.startDate.rootEl.parentElement.classList.add('error');
            errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('general.mandatoryField', Monet.I18n.getResourcesByKey('SmartGeocode.form.date')));
        }

        //Check if start date is greater than end date
        if (formData.startDate && formData.endDate) {
            const endDateIsGreater = dateFunctions.validateDateGreaterOrEqualThan(fields.startDate.getValue(), fields.endDate.getValue());
            if (!endDateIsGreater) {
                isValid = false;
                fields.startDate.rootEl.parentElement.classList.add('error');
                errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('SmartGeocode.form.startDateIsGreater'));
            }
        }

        //Check if dates are in the future
        if (formData.endDate || formData.startDate) {
            [fields.startDate, fields.endDate].forEach((field) => {
                const dateIsInFuture = dateFunctions.validateIfDateIsInFuture(field.getValue());
                if (dateIsInFuture) {
                    field.rootEl.classList.add('error');
                    isValid = false;
                    errorMessages.push(
                        Monet.Form.Messages.mountErrorMessageObject('SmartGeocode.form.dateIsInTheFuture')
                    );
                }
            });
        }

        //Set and render error messages
        if(!isValid) {
            this.renderErrorMessages(errorMessages);
        }
        else {
            const alert = document.querySelector('#SmartGeocode .alert');
            alert && (alert.style.display = 'none');
        }
        
        return { isValid, data: formData };
    };

    this.triggerLoaderInBtn = () => {
        [this.processButtonTop, this.processButtonBottom].forEach(button => button.toggleLoadingInBtn());
    };


    this.getProcessState = function () {
        const form = this.validateForm();
        const router = new App.Routers.MassiveSmartGeocode();
        
        if (form.isValid) {
            this.triggerLoaderInBtn();
        
            const processStateSuccess = (data) => {
                const { status, processStatus } = data;
        
                if (status === 'NOT_FOUND' || (status === 'PROCESSED' && processStatus === 1)) {
                    this.startProcess();
                } else if (status === 'PROCESSING') {
                    App.Views.MassiveSmartGeocode.showProgressBar(processStatus, 'processingForm');
                    this.triggerLoaderInBtn();
                }
            };
        
            const processStateError = (errorMessages) => {
                this.triggerLoaderInBtn();
                this.renderErrorMessages(errorMessages);
            };
        
            router.getProcessState(processStateSuccess, processStateError);
        }
    }


    this.startProcess = function() {
        const form = this.validateForm();
        const router = new App.Routers.MassiveSmartGeocode();

        const successCallback = (data) => {
            App.Views.MassiveSmartGeocode.showProgressBar(data.processStatus);
        }

        const errorCallback = (errorMessages) => {
            this.triggerLoaderInBtn();
            this.renderErrorMessages(errorMessages);
        };

        router.startProcess(form.data, successCallback, errorCallback);
    };

    this.initRadioGroup = function () {
        const fields = App.Forms.MassiveSmartGeocode.form.fields;

        //Create radio group field
        fields.searchBy = fields.searchBy || new Monet.UI.Fields.Render({
            label: '',
            type: 'RADIO_GROUP',
            id: 'searchBy',
            defaultValue: 'organization',
            fieldDomains: [{
                value: 'organization',
                description: 'SmartGeocode.form.organizations',
                id: 'radioOrganization'
            }, {
                value: 'location',
                description: 'SmartGeocode.form.locations',
                id: 'radioLocation'
            }]
        }, 'RadioGroup').render();

        fields.searchBy.rootEl.id = 'radios_container';

        //Add listener for displaying and hiding fields according to the option selected
        const radios = fields.searchBy.getRadioButtons();

        const adjustFields = () => {
            const checkedRadio = fields.searchBy.getValue();

            radios.forEach((radioOption) => {
                const radioValue = radioOption.getValue();
                const field = fields[radioValue];

                if (radioValue === checkedRadio) {
                    field.rootEl.style.display = 'block';
                    field.setMandatory(true);
                }
                if (radioValue !== checkedRadio) {
                    field.rootEl.style.display = 'none';
                    field.setMandatory(false);
                }
            });
        };

        radios.forEach((radioOption) => {
            radioOption.rootEl.addEventListener('change', adjustFields);
        });

        adjustFields();

        return fields.searchBy.rootEl;
    };

    this.renderMandatoryFields = function () {

        const fields = App.Forms.MassiveSmartGeocode.form.fields;

        //Organization/location fields
        fields.organization = fields.organization || new Monet.UI.Fields.Render({
            name: 'organization',
            label: 'SmartGeocode.form.organizations',
            type: 'LOOKUP_LIST',
            lookupEntity: 'Organization',
            lookupEntityColumn: 'description',
        }, 'SmartGeocode').render();

        fields.location = fields.location || new Monet.UI.Fields.Render({
            name: 'location',
            label: 'SmartGeocode.form.locations',
            type: 'LOOKUP_LIST',
            lookupEntity: 'Location',
            lookupEntityColumn: 'description',
        }, 'SmartGeocode').render();

        //Date interval fields
        fields.startDate = fields.startDate || new Monet.UI.Fields.Render({
            name: 'startDate',
            label: 'SmartGeocode.form.startDate',
            mandatory: true,
            type: 'DATE',
        }, 'SmartGeocode').render();

        fields.endDate = fields.endDate || new Monet.UI.Fields.Render({
            name: 'endDate',
            label: 'SmartGeocode.form.endDate',
            mandatory: true,
            type: 'DATE',
        }, 'SmartGeocode').render();

        //Add fields to section
        const mandatoryFieldsContainer = document.createElement('div');
        mandatoryFieldsContainer.className = 'mandatoryFieldsContainer';
        mandatoryFieldsContainer.appendChild(this.initRadioGroup());
        mandatoryFieldsContainer.appendChild(fields.organization.rootEl);
        mandatoryFieldsContainer.appendChild(fields.location.rootEl);

        const datesContainer = document.createElement('div');
        datesContainer.id = 'dates_container';
        datesContainer.appendChild(fields.startDate.rootEl);
        datesContainer.appendChild(fields.endDate.rootEl);
        mandatoryFieldsContainer.appendChild(datesContainer);

        return mandatoryFieldsContainer;
    }

    this.renderOptionalFields = function () {  
        
        const fields = App.Forms.MassiveSmartGeocode.form.fields;

        //Drivers fields
        fields.picklistDriver = fields.picklistDriver || new Monet.UI.Fields.Render({
            name: 'picklistDriver',
            defaultValue: 'INCLUDE',
            type: 'PICKLIST',
            fieldDomains: [
                {
                    description: 'SmartGeocode.form.includeDrivers',
                    value: 'INCLUDE'
                },
                {
                    description: 'SmartGeocode.form.excludeDrivers',
                    value: 'EXCLUDE'
                }
            ]
        }, 'SmartGeocode').render();

        fields.driver = fields.driver || new Monet.UI.Fields.Render({
            name: 'driver',
            label: 'SmartGeocode.form.drivers',
            mandatory: false,
            type: 'LOOKUP_LIST',
            lookupEntity: 'Driver',
            lookupEntityColumn: 'name',
        }, 'SmartGeocode').render();

        //Equipment fields
        fields.picklistEquipment = fields.picklistEquipment || new Monet.UI.Fields.Render({
            name: 'picklistEquipment',
            defaultValue: 'INCLUDE',
            type: 'PICKLIST',
            fieldDomains: [
                {
                    description: 'SmartGeocode.form.includeEquipment',
                    value: 'INCLUDE'
                },
                {
                    description: 'SmartGeocode.form.excludeEquipment',
                    value: 'EXCLUDE'
                },
            ]
        }, 'SmartGeocode').render();

        fields.equipment = fields.equipment || new Monet.UI.Fields.Render({
            name: 'equipment',
            label: 'Equipment',
            mandatory: false,
            type: 'LOOKUP_LIST',
            lookupEntity: 'Equipment',
            lookupEntityColumn: 'description',
        }, 'SmartGeocode').render();

        //Routes fields
        fields.picklistRoute = fields.picklistRoute || new Monet.UI.Fields.Render({
            name: 'picklistRoute',
            defaultValue: 'INCLUDE',
            type: 'PICKLIST',
            fieldDomains: [
                {
                    description: 'SmartGeocode.form.includeRoutes',
                    value: 'INCLUDE'
                },
                {
                    description: 'SmartGeocode.form.excludeRoutes',
                    value: 'EXCLUDE'
                },
            ]
        }, 'SmartGeocode').render();

        fields.route = fields.route || new Monet.UI.Fields.Render({
            name: 'route',
            label: 'SmartGeocode.form.routes',
            mandatory: false,
            type: 'LOOKUP_LIST',
            lookupEntity: 'Route',
            lookupEntityColumn: 'description',
        }, 'SmartGeocode').render();

        //Add fields to section
        const driversContainer = document.createElement('div');
        driversContainer.appendChild(fields.picklistDriver.rootEl);
        driversContainer.appendChild(fields.driver.rootEl);

        const equipmentContainer = document.createElement('div');
        equipmentContainer.appendChild(fields.picklistEquipment.rootEl);
        equipmentContainer.appendChild(fields.equipment.rootEl);

        const routesContainer = document.createElement('div');
        routesContainer.appendChild(fields.picklistRoute.rootEl);
        routesContainer.appendChild(fields.route.rootEl);

        const optionalFieldsContainer = document.createElement('div');
        optionalFieldsContainer.className = 'optionalFieldsContainer';
        optionalFieldsContainer.appendChild(driversContainer);
        optionalFieldsContainer.appendChild(equipmentContainer);
        optionalFieldsContainer.appendChild(routesContainer);

        return optionalFieldsContainer;
    }

    this.renderProcessButton = function () {
        const processButton = new Monet.UI.Fields.Render({
            customJavaScript: () => this.getProcessState(),
            label: 'SmartGeocode.form.processButton',
            type: 'BUTTON'
        }).render();
        processButton.rootEl.className = 'MonetUIButton processButton';
        return processButton;
    };

    this.renderForm = function (options) {

        App.Forms.MassiveSmartGeocode.form = App.Forms.MassiveSmartGeocode.form || new Monet.Builder.Form.Base();
        
        //Remove errors and fix filter builders when form is rerendered
        const fields = App.Forms.MassiveSmartGeocode.form.fields;
        for (const key in fields) {
            const field = fields[key];
            field.rootEl.classList.remove('error');
            field.rootEl.parentElement.classList.remove('error');
            if (field.filter) {
                field.filter.renderSpecialSelect();
            }
        }

        //Create alerts
        const alertContainer = document.createElement('div');
        alertContainer.className = 'monetInlineAlerContainer';

        //Create top buttons     
        const buttonTopSection = document.createElement('div');
        buttonTopSection.className = 'MonetUIFormSection';  
        const buttonTop = document.createElement('div');
        buttonTop.className = 'MonetUIFormSectionButton buttonsUp';
        buttonTop.appendChild(new Monet.UI.Help('SmartGeocode', Monet.I18n.getResourcesByKey('SmartGeocode.title')).renderLink());
        this.processButtonTop = this.renderProcessButton();
        buttonTop.appendChild(this.processButtonTop.rootEl);
        buttonTopSection.appendChild(buttonTop);

        //Create page title
        const pageTitle = document.createElement('div');
        const titleH1 = document.createElement('h1');
        pageTitle.className = 'MonetUIFormSectionTitle';           
        titleH1.innerText = Monet.I18n.getResourcesByKey('SmartGeocode.title');
        pageTitle.appendChild(titleH1);  

        //Create fields
        const fieldsContainer = document.createElement('div');
        fieldsContainer.id = 'fields_container';
        fieldsContainer.appendChild(this.renderMandatoryFields());
        fieldsContainer.appendChild(this.renderOptionalFields());       

        //Create bottom button   
        const buttonBottomSection = document.createElement('div');
        buttonBottomSection.className = 'MonetUIFormSection';  
        const buttonBottom = document.createElement('div');
        buttonBottom.className = 'MonetUIFormSectionButton buttonsBottom';
        this.processButtonBottom = this.renderProcessButton();
        buttonBottom.appendChild(this.processButtonBottom.rootEl);
        buttonBottomSection.appendChild(buttonBottom);

        //Render form and add radio button listeners
        const tab = document.querySelector("#SmartGeocode");
        const tabContent = document.createElement('div');
        const form = document.createElement('form');
        form.className = 'MonetUIForm SmartGeocode';
        form.appendChild(alertContainer);
        form.appendChild(buttonTopSection);
        form.appendChild(pageTitle);
        form.appendChild(fieldsContainer);
        form.appendChild(buttonBottomSection);
        tabContent.id = 'form_and_grid';
        tabContent.appendChild(form);
        tab.appendChild(tabContent);

        if (options && options.errorMessages) {
            this.renderErrorMessages(options.errorMessages);
        }
    };

};
